
import { PERIODE_MATI, PERIODE_MIGDIA, PERIODE_VESPRE } from '../../constants.js';

/**
 * A partir del nom d'un moment, retorna el periode assignat.
 * Per exemple: els moments '24h' i 'Acum dia pluviomètric' tenen asignat el periode mati per defecte.
 * @param nomMoment {String}
 * @returns {String} || {null}
 */
export function buscarPeriode(nomMoment) {
    if (PERIODE_MATI.indexOf(nomMoment) !== -1 ) {
        return '7h';
    }

    if (PERIODE_MIGDIA.indexOf(nomMoment) !== -1 ) {
        return '13h';
    }

    if (PERIODE_VESPRE.indexOf(nomMoment) !== -1 ) {
        return '18h';
    }

    return null;
}

/**
 * A partir de l'hora d'un moment, retorna el codi de moment assignat.
 * Per exemple: donada una horaMoment '7h' retornaria codi de moment 1.
 * @param horaMoment {String}
 * @returns {Number} || {null}
 */
export function obtenirCodiMoment(horaMoment) {
    switch (horaMoment) {
        case '7h':
            return 1;
        case '13h':
            return 2;
        case '18h':
            return 3;
        default:
            return null;
    }
}

/**
 * A partir de l'hora d'un moment, retorna el nom assignat.
 * Per exemple: donada una horaMoment '7h' retornaria nom de moment 'Matí'.
 * @param horaMoment {String}
 * @returns {String} || {null}
 */
export function obtenirNomMoment(horaMoment) {
    switch (horaMoment) {
        case '7h':
            return 'Matí';
        case '13h':
            return 'Migdia';
        case '18h':
            return 'Vespre';
        default:
            return null;
    }
}

/**
 * A partir d'una data de consulta en {Moment} i l'hora d'un moment, retorna
 * la data de l'observació amb l'hora per defecte del moment associat.
 * Per exemple: donada una data de consulta '2017-08-09T00:00Z' i una horaMoment '7h'
 * retornaria un objecte {Moment} amb valor '2017-08-09T07:00Z'.
 * @param dataConsulta {Moment}
 * @param horaMoment {String}
 * @returns {Moment} || {null}
 */
export function obtenirHoraObservacioDeMomentPerDefecte(dataConsulta, horaMoment) {
    switch (horaMoment) {
        case '7h':
            return dataConsulta.clone().hours(7).minutes(0).seconds(0);
        case '13h':
            return dataConsulta.clone().hours(13).minutes(0).seconds(0);
        case '18h':
            return dataConsulta.clone().hours(18).minutes(0).seconds(0);
        default:
            return null;
    }
}

/**
 * A partir d'una hora d'un moment, retorna l'hora per defecte del moment associat en text.
 * Per exemple: donada una horaMoment '7h' retornaria '07:00+00'.
 * @param horaMoment {String}
 * @returns {String} || {null}
 */
export function obtenirHoraUTC(horaMoment) {
    switch (horaMoment) {
        case '7h':
            return '07:00+00';
        case '13h':
            return '13:00+00';
        case '18h':
            return '18:00+00';
        default:
            return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/commons/periodes.js